import React from 'react';
import { Sun, Moon } from 'lucide-react';
import '../styles/DarkModeToggle.css';

const DarkModeToggle = ({ isDark, onToggle }) => {
  return (
    <div className="dark-mode-toggle">
      <button
        className={`theme-toggle ${isDark ? 'dark' : 'light'}`}
        onClick={() => onToggle(!isDark)}
        title={`Switch to ${isDark ? 'light' : 'dark'} mode`}
        aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      >
        {isDark ? <Sun size={20} aria-hidden="true" /> : <Moon size={20} aria-hidden="true" />}
      </button>
    </div>
  );
};

export default DarkModeToggle;
